import BaseMessageHandler from '../BaseMessageHandler';
import { updateDataItem } from 'actions/getData';

export default class Invoice_Cancel extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateDataItem('invoices', 'transaction_id', message.payload));
  };
}
